import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "col-12 px-0" }
const _hoisted_2 = { class: "d-flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon mr-2 icon-kalender",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_4 = { class: "my-2" }
const _hoisted_5 = { class: "row mx-auto" }
const _hoisted_6 = { class: "col-12 col-md-4 d-flex bg-lightblue p-3 kapazitaetrow" }
const _hoisted_7 = { class: "col-12 col-md-4 d-flex bg-lightblue p-3 kapazitaetrow" }
const _hoisted_8 = { class: "col-12 col-md-4 d-flex bg-lightblue p-3 kapazitaetrow" }
const _hoisted_9 = { class: "row mx-auto mt-3" }
const _hoisted_10 = { class: "col-12 col-md-6 pl-md-0" }
const _hoisted_11 = { class: "col-12 col-md-6 pr-md-0" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "row mx-auto mt-4" }
const _hoisted_14 = { class: "col-12 col-md-4 offset-md-2 col-lg-3 offset-lg-3 mt-1 px-xs-0" }
const _hoisted_15 = { class: "col-12 col-md-4 col-lg-3 mt-1 px-xs-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_link_back = _resolveComponent("link-back")!
  const _component_control_time = _resolveComponent("control-time")!
  const _component_control_integer = _resolveComponent("control-integer")!
  const _component_control_date = _resolveComponent("control-date")!
  const _component_control_checkbox = _resolveComponent("control-checkbox")!
  const _component_control_week_days = _resolveComponent("control-week-days")!
  const _component_button_cancel = _resolveComponent("button-cancel")!
  const _component_button_save = _resolveComponent("button-save")!
  const _component_loading_container = _resolveComponent("loading-container")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", _hoisted_2, [
        _hoisted_3,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('views.timeSlotAdd.title')), 1)
      ])
    ]),
    _createVNode(_component_link_back, {
      to: { name: 'admin-time-slots', params: { id: _ctx.roomId } },
      i18nMessage: "common.backToOverview",
      class: "mt-2"
    }, null, 8, ["to"]),
    _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.room.name), 1),
    _createVNode(_component_loading_container, {
      state: _ctx.state,
      i18nErrorMessage: _ctx.getI18nErrorString()
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.onSubmit()), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_control_time, {
                i18nLabel: "common.timeSlot.startTime",
                validation: _ctx.v$.startTime,
                modelValue: _ctx.startTime,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.startTime) = $event)),
                showBreak: true,
                class: "d-flex flex-wrap align-items-center mr-3"
              }, null, 8, ["validation", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_control_time, {
                i18nLabel: "common.timeSlot.endTime",
                validation: _ctx.v$.endTime,
                modelValue: _ctx.endTime,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.endTime) = $event)),
                showBreak: true,
                class: "d-flex flex-wrap align-items-center mr-3"
              }, null, 8, ["validation", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_control_integer, {
                i18nLabel: "common.timeSlot.capacity",
                validation: _ctx.v$.capacity,
                modelValue: _ctx.capacity,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.capacity) = $event)),
                showBreak: true,
                class: "d-flex flex-wrap align-items-center mr-3"
              }, null, 8, ["validation", "modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_control_date, {
                i18nLabel: "common.timeSlot.startDate",
                validation: _ctx.v$.startDate,
                modelValue: _ctx.startDate,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.startDate) = $event)),
                onChange: _ctx.setEndDate
              }, null, 8, ["validation", "modelValue", "onChange"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_control_date, {
                i18nLabel: "common.timeSlot.repeatUntil",
                validation: _ctx.v$.repeatUntil,
                modelValue: _ctx.repeatUntil,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.repeatUntil) = $event)),
                onChange: _ctx.showRepeaterFunc
              }, null, 8, ["validation", "modelValue", "onChange"])
            ])
          ]),
          (_ctx.showRepeater)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_control_week_days, {
                  i18nLabel: "common.timeSlot.daysOfWeek",
                  validation: _ctx.v$.daysOfWeek,
                  modelValue: _ctx.daysOfWeek,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.daysOfWeek) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_control_checkbox, {
                      i18nLabel: "common.timeSlot.includeHolidays",
                      validation: _ctx.v$.includeHolidays,
                      modelValue: _ctx.includeHolidays,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.includeHolidays) = $event)),
                      class: "mt-3 mb-0"
                    }, null, 8, ["validation", "modelValue"])
                  ]),
                  _: 1
                }, 8, ["validation", "modelValue"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_button_cancel, {
                to: { name: 'admin-time-slots', PARAMS: { id: _ctx.roomId }},
                class: "btn-w-100"
              }, null, 8, ["to"])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_button_save, {
                i18nMessage: "common.timeSlot.add",
                class: "btn-w-100"
              })
            ])
          ])
        ], 32)
      ]),
      _: 1
    }, 8, ["state", "i18nErrorMessage"])
  ]))
}